import { State } from "@/store/modules/poll/index";

const setPoll = (state: State, payload: any): void => {
    state.poll = payload;
};

const setPollTime = (state: State, payload: any): void => {
    state.pollTime = payload;
};

export default {
    setPoll,
    setPollTime
};